var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.08V16C22.4988 18.1564 21.8005 20.2547 20.5093 21.9818C19.2182 23.709 17.4033 24.9725 15.3354 25.5839C13.2674 26.1953 11.0573 26.1219 9.03447 25.3746C7.01168 24.6273 5.28465 23.2461 4.11096 21.4371C2.93727 19.628 2.37979 17.4881 2.52168 15.3363C2.66356 13.1846 3.49721 11.1363 4.89828 9.49706C6.29935 7.85781 8.19279 6.71537 10.2962 6.24013C12.3996 5.7649 14.6003 5.98232 16.57 6.85999",
    stroke: "#27D916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8L12.5 18.01L9.5 15.01",
    stroke: "#27D916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIcon);
export default __webpack_public_path__ + "static/media/register-icon.0b9693cffa137092d5494724a79fc0ff.svg";
export { ForwardRef as ReactComponent };